import React, { useCallback } from 'react';
import Modal from 'react-native-modal';
import { Icon, CheckBox } from 'react-native-elements';
import { View, Text, ActivityIndicator } from 'react-native';
import styles from '../styles';
import ServiceLine from '../../ledger/components/LedgerLine';
import { DescriptionField } from '../../../components/FormField';
import config from '../../../lib/config';
import CloseButton from './CircleButton';
import HeaderOverlay from '../../../components/HeaderOverlay';
import { useDispatch } from 'react-redux';
import { hideModal } from '../../../store/appSlice';

interface Props {
  date: string;
  category: string;
  sub_category?: string;
  unit: string;
  description: string;
  briefDescription: string;
  status: string;
  allowSuiteAccess: boolean;
  isLoading: boolean;
}

const ServiceRequestDetailOverlay: React.FC<Props> = ({
  date,
  category,
  sub_category,
  unit,
  description,
  briefDescription,
  status,
  allowSuiteAccess,
  isLoading,
}) => {
  const dispatch = useDispatch();
  const onClose = useCallback(() => {
    dispatch(hideModal());
  }, [dispatch]);

  return (
    <Modal
      style={styles.modalStyle}
      swipeDirection="down"
      onSwipeComplete={onClose}
      isVisible
    >
      <>
        <HeaderOverlay onClose={onClose} />
        <View style={styles.modalContent}>
          <Text style={styles.modalTitle}>Service Request</Text>
          <View style={styles.modalBody}>
            <View style={styles.headerRequest}>
              <ServiceLine
                customTitleStyle={styles.serviceLine}
                title="Date"
                label={date}
              />
              <ServiceLine
                customTitleStyle={styles.serviceLine}
                title="Unit#"
                label={unit}
              />
            </View>
            <ServiceLine
              customTitleStyle={styles.serviceLine}
              title="Category"
              label={category}
            />
            {sub_category ? (
              <ServiceLine
                customTitleStyle={styles.serviceLine}
                title="Sub Category"
                label={sub_category}
              />
            ) : (
              <View />
            )}
            <DescriptionField
              customContainerStyle={styles.descriptionContainer}
              customLabelStyle={styles.description}
              label="Brief Description"
              disabled
              intinalValue={briefDescription}
            />
            <DescriptionField
              customContainerStyle={styles.descriptionContainer}
              customLabelStyle={styles.description}
              label="Description"
              disabled
              intinalValue={description}
            />
            <ServiceLine
              customTitleStyle={styles.serviceLine}
              customStyle={styles.marginServiceLine}
              title="Status"
              label={status}
            />
            <CheckBox
              iconType="ionicon"
              uncheckedIcon="square-outline"
              checkedIcon="checkbox-outline"
              textStyle={styles.checkboxTitle}
              containerStyle={styles.checkbox}
              style={styles.checkboxContainer}
              checkedColor={config.theme.headingTextColor}
              checked={Boolean(allowSuiteAccess)}
              title="Allow Suite Access"
            />
            <CloseButton onPress={onClose} />
            <ActivityIndicator
              color={config.theme.brandColor}
              animating={isLoading}
            />
          </View>
        </View>
      </>
    </Modal>
  );
};

export default ServiceRequestDetailOverlay;
